import { render, staticRenderFns } from "./RecentContributions.vue?vue&type=template&id=a455a64e&scoped=true"
import script from "./RecentContributions.vue?vue&type=script&lang=ts"
export * from "./RecentContributions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a455a64e",
  null
  
)

export default component.exports